export default __webpack_public_path__ + "static/media/20250524-AZ400.ea8593f3.jpg";